import Vue from 'vue'

import App from './App.vue'

import router from './router'
import store from './store'
import i18n from './i18n.js'
import tracking from './functions/tracking'

import './main.scss'

import { SENTRY_DSN, SENTRY_TUNNEL, SENTRY_RELEASE, SENTRY_ENVIRONMENT, SENTRY_SAMPLE_RATE } from './settings'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

Sentry.init({
  Vue,
  dsn: SENTRY_DSN,
  tunnel: SENTRY_TUNNEL,
  integrations: [new Integrations.BrowserTracing({
    routingInstrumentation: Sentry.vueRouterInstrumentation(router)
  })],

  release: SENTRY_RELEASE,
  environment: SENTRY_ENVIRONMENT,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: parseFloat(SENTRY_SAMPLE_RATE),

  // by default errors aren't logged to the console
  // when the sentry integration is enabled. That is
  // kind of inconvienent, so enable it back.
  logErrors: true
})

Vue.prototype.$tracking = tracking
Vue.prototype.$tracking.init()

function mounted () {
  // Remove fallback CSS
  const fallbackCSSlink = document.querySelector('#fallback-css')
  fallbackCSSlink.parentNode.removeChild(fallbackCSSlink)
}

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  mounted,
  render: h => h(App)
})
